export default "__VITE_ASSET__BtATdKH5__"